/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GenericDocExternalPicker from 'shared/ui/components/form-components/pickers/GenericDocExternalPicker.vue';
import ResetSessionCheckInDataModal from './ResetSessionCheckInDataModal.vue';

const __vue_script__ = {
    name: 'ResetSessionCheckInData',

    components: {
        GenericDocExternalPicker,
    },

    props: {
        event: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            selected: [],
        };
    },

    computed: {
        hasNoSelectedSessions() {
            return this.selected.length === 0;
        }
    },

    methods: {
        confirmReset() {
            if (this.hasNoSelectedSessions) return;
            const onReset = () => { this.selected = []; };
            this.$modal.show(
                ResetSessionCheckInDataModal,
                { eid: this.event._id, sessions: this.selected, onReset },
                { height: 'auto' },
            );
        },
    },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "reset-session-check-in-data" },
    [
      _c("generic-doc-external-picker", {
        attrs: {
          "event-id": _vm.event._id,
          placeholder: _vm.$t("assisted_check_in.actions.choose_sessions"),
          label: _vm.$t("assisted_check_in.actions.select_sessions"),
          "fp-type": "session",
          emitObjects: true,
          multiple: true,
          sortable: false,
          name: "sessions",
        },
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
      _c(
        "button",
        {
          staticClass: "btn btn-danger",
          attrs: { type: "button", disabled: _vm.hasNoSelectedSessions },
          on: {
            click: function ($event) {
              return _vm.confirmReset()
            },
          },
        },
        [
          _vm._v(
            _vm._s(
              _vm.$t(
                "assisted_check_in.actions.reset_session_check_in_data_plural"
              )
            )
          ),
        ]
      ),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/session-check-in/ResetSessionCheckInData.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__